var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2383 21.3146C10.919 25.2882 9.21734 25.1518 5.7985 25.1518C7.47633 24.7925 8.70737 24.3254 10.7355 20.3316C12.358 17.1365 16.1641 16.6712 17.8643 16.8379C17.31 17.0085 15.5577 17.341 13.2383 21.3146Z",
    fill: "url(#paint0_linear_1346_2962)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2383 12.3455C10.919 8.37194 9.21734 8.50838 5.7985 8.50837C7.47633 8.8677 8.70737 9.33473 10.7355 13.3286C12.358 16.5237 16.1641 16.989 17.8643 16.8222C17.31 16.6517 15.5577 16.3191 13.2383 12.3455Z",
    fill: "url(#paint1_linear_1346_2962)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3906 21.3146C22.7099 25.2882 24.4116 25.1518 27.8304 25.1518C26.1526 24.7925 24.9215 24.3254 22.8934 20.3316C21.2709 17.1365 17.4649 16.6712 15.7646 16.8379C16.3189 17.0085 18.0712 17.341 20.3906 21.3146Z",
    fill: "url(#paint2_linear_1346_2962)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3906 12.3455C22.7099 8.37194 24.4116 8.50838 27.8304 8.50838C26.1526 8.8677 24.9215 9.33473 22.8934 13.3286C21.2709 16.5237 17.4649 16.989 15.7646 16.8222C16.3189 16.6517 18.0712 16.3191 20.3906 12.3455Z",
    fill: "url(#paint3_linear_1346_2962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_2962",
    x1: 17.8643,
    y1: 20.9805,
    x2: 5.7985,
    y2: 20.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1346_2962",
    x1: 17.8643,
    y1: 12.6797,
    x2: 5.79849,
    y2: 12.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1346_2962",
    x1: 15.7646,
    y1: 20.9805,
    x2: 27.8304,
    y2: 20.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1346_2962",
    x1: 15.7646,
    y1: 12.6797,
    x2: 27.8304,
    y2: 12.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.0597e70036106fbc1233ffb717479557.svg";
export { ForwardRef as ReactComponent };